var $5a41bb2baa6861e4$exports = {};
$5a41bb2baa6861e4$exports = {
  "breadcrumbs": "Br\xF8dkrummer"
};
export { $5a41bb2baa6861e4$exports as default };